const API_ROOT = process.env.REACT_APP_API_IO_ROOT;

const api = {};

api.validateTrial = (password) => {
  return post("v1/trial/validate", { password: password });
};

api.addTrialEmail = (email, token) => {
  return post("v1/trial/email", { email: email, token: token });
};

api.getTestUrlForToken = (token) => {
  return post("v1/trial/url", { token: token });
};

api.getCNBData = (subid) => {
  return post("cnb/data", { subid: subid });
};

const post = (path, data = null) => {
  return fetch(API_ROOT + path, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
    credentials: "include",
    mode: "cors",
  })
    .then((res) => {
      return res.json();
    })
    .then((result) => {
      return result;
    });
};

module.exports = api;
